<template>
  <footer class="_dashboard-body">
    <div class="container-fluid px-4">
      <div class="row">
        <div class="col-12 text-center text-secondary">
          <div class="bg-white p-3 small">
            &copy; Copyright
            2022 - <b>Metta<span class="text-red">DC</span></b> | All Rights Reserved
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="exampleModalConfirmation" tabindex="-1" data-bs-backdrop="static"
      data-bs-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title fs-6" id="exampleModalLabel"><i class="fa-fw fa fa-exclamation-circle"></i>
              Attention!</div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="bg-light rounded-2 py-3 px-4 text-center">
              <div class="mb-3 text-yellow"><i class="fa-fw fa fa-exclamation-triangle fa-4x"></i></div>
              <div class="fw-bold mb-2">You Are Going To Perform This Action!</div>
              <div class="small">Are you sure?</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-red" data-bs-target="#exampleModalSuccess"
              data-bs-toggle="modal"><i class="fa-fw fa fa-save"></i> Yes</button>
            <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal"><i
                class="fa-fw fa fa-times"></i> Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="exampleModalSuccess" tabindex="-1" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm">
        <div class="modal-content">
          <div class="modal-body">
            <div class="bg-light rounded-2 py-3 px-4 text-center">
              <div class="mb-3 text-green"><i class="fa-fw fa fa-check-circle fa-4x"></i></div>
              <div class="fw-bold mb-2">Operation Succeed!</div>
              <div class="small">You reqeust has been procedd successfully.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@media (max-width: 575px) {
  footer {
    height: 29px;
    // background-color: #301551;
    background-color: #FFFFFF;
    color: #333;
    width: 100%;
  }
}

@media (min-width: 576px) {
  footer {
    height: 29px;
    // background-color: #301551;
    background-color: #fff;
    color: #333;
    width: 100%;
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  footer {
    height: 29px;
    background-color: #fff;
    color: #333;
    width: 100%;
  }
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {}
</style>
